import { DropdownInput } from '@dealstack/frontend/shared/components/DropdownInput/DropdownInput';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { DefaultColumnRenderer } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { ColumnRendererProps } from '@dealstack/frontend/shared/components/Table/Table/types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { VestingTermSimplifiedRes } from '@dealstack/shared/lib/generated';
import { ActionIcon, Button, Text } from '@mantine/core';
import classNames from 'classnames';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

interface Props {
	openBulkUpdate: () => void;
	onBulkUpdate: (vestingTermId: string) => void;
	closeBulkUpdate: () => void;
	bulkUpdate: boolean;
	vestingTerms?: VestingTermSimplifiedRes[];
	tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>;
}

export const ColumnRenderer =
	({
		openBulkUpdate,
		onBulkUpdate,
		bulkUpdate,
		closeBulkUpdate,
		vestingTerms,
		tCommonUi,
	}: Props) =>
	(props: ColumnRendererProps): JSX.Element => {
		if (props.column.id === 'vesting-button') {
			if (bulkUpdate) {
				return (
					<div className="px-4" style={props.style}>
						<div className="flex items-center pb-1 font-bold pt-1">
							<DropdownInput
								options={
									vestingTerms?.map((vestingTerm) => ({
										label: vestingTerm.name,
										value: vestingTerm.id,
									})) ?? []
								}
								value=""
								onChange={onBulkUpdate}
								leftSection={
									<ActionIcon
										variant="transparent"
										c="dark.8"
										p="0"
										size="xs"
										mr="0.5rem"
										onClick={(ev) => {
											ev.stopPropagation();
											closeBulkUpdate();
										}}
									>
										<Icon variant="close-v3" size="md" />
									</ActionIcon>
								}
								placeholder={tCommonUi('common_placeholders.select')}
								targetSx={(theme) => ({
									borderColor: theme.colors.blue[2],
									backgroundColor: theme.colors.blue[0],
								})}
							/>
						</div>
					</div>
				);
			} else {
				return (
					<div className="px-4" style={props.style}>
						<div className="flex items-center pb-1 font-bold pt-1">
							<Button
								variant="default"
								c="blue.6"
								radius="md"
								fullWidth
								leftSection={<Icon variant="bulls-eye" size="vlg" />}
								onClick={() => openBulkUpdate()}
								sx={{ display: 'flex' }}
							>
								<Text variant="button" c="dark.8">
									{tCommonUi('common_buttons.bulk_update')}
								</Text>
							</Button>
						</div>
					</div>
				);
			}
		} else {
			return (
				<DefaultColumnRenderer
					{...props}
					className={classNames('px-4', {
						'text-left border-b border-solid border-gray-300':
							props.column.id === 'vesting',
					})}
				/>
			);
		}
	};
